// Angular:
import { Component, HostBinding, Input } from '@angular/core';

// Dependencies:
import { isNotNull, Value } from '@trademe/ensure';
import { StepIndicatorItemComponent } from '../step-indicator-item/step-indicator-item.component';
import { StepIndicatorComponent } from '../step-indicator/step-indicator.component';

@Component({
    selector: 'tm-step-indicator-step-button',
    templateUrl: 'step-indicator-step-button.component.html'
})
export class StepIndicatorStepButtonComponent {
    @Input() @Value(isNotNull) public item: StepIndicatorItemComponent;
    @HostBinding('class.o-step-indicator-step-button')
    public stepIndicatorStepButton = true;

    constructor(private _stepIndicator: StepIndicatorComponent) {}

    public select(): void {
        this._stepIndicator.select(this.item);
    }
}
